/**
 * HYCO Trusted Reviews: Swiper with progress bar and arrow navigation.
 */

(function () {
  'use strict';

  const DESKTOP_BREAKPOINT = 990;

  /**
   * Syncs disabled state on custom arrow buttons.
   * @param {object} swiper Swiper instance
   * @param {HTMLElement} prevEl
   * @param {HTMLElement} nextEl
   */
  function updateNavState(swiper, prevEl, nextEl) {
    if (!prevEl || !nextEl) {
      return;
    }

    const locked = swiper.isLocked;
    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;

    prevEl.disabled = locked || atStart;
    nextEl.disabled = locked || atEnd;
    prevEl.setAttribute('aria-disabled', prevEl.disabled ? 'true' : 'false');
    nextEl.setAttribute('aria-disabled', nextEl.disabled ? 'true' : 'false');
    prevEl.classList.toggle('hyco-trusted-reviews__nav-btn--inactive', atStart);
    nextEl.classList.toggle('hyco-trusted-reviews__nav-btn--inactive', atEnd);
  }

  /**
   * @param {HTMLElement} container
   */
  function destroyIfNeeded(container) {
    const el = container.querySelector('.hyco-trusted-reviews__swiper');
    if (el && el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  /**
   * @param {HTMLElement} container
   */
  function initTrustedReviews(container) {
    const Swiper = window.Swiper;
    if (typeof Swiper !== 'function') {
      return;
    }

    const swiperEl = container.querySelector('.hyco-trusted-reviews__swiper');
    if (!swiperEl) {
      return;
    }

    destroyIfNeeded(container);

    const nextEl = container.querySelector('.hyco-trusted-reviews__nav-next');
    const prevEl = container.querySelector('.hyco-trusted-reviews__nav-prev');
    const paginationEl = container.querySelector(
      '.hyco-trusted-reviews__pagination',
    );

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.7,
      spaceBetween: 8,
      speed: 450,
      watchOverflow: true,
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
      breakpoints: {
        [DESKTOP_BREAKPOINT]: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
      },
      on: {
        afterInit(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
        slideChange(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
        resize(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
      },
    });

    updateNavState(swiper, prevEl, nextEl);
  }

  function initAll() {
    document.querySelectorAll('[data-hyco-trusted-reviews]').forEach(
      function bindEach(root) {
        initTrustedReviews(root);
      },
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function onSectionLoad(ev) {
    const root = ev.target.querySelector('[data-hyco-trusted-reviews]');
    if (root) {
      initTrustedReviews(root);
    }
  });

  document.addEventListener('shopify:section:unload', function onSectionUnload(
    ev,
  ) {
    const root = ev.target.querySelector('[data-hyco-trusted-reviews]');
    if (root) {
      destroyIfNeeded(root);
    }
  });
})();
